import React, { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import Header from "./common/Header";
import ContentIndex from "./index/Content";
import Footer from "./common/Footer";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheckSquare,
  faCoffee,
  faMobileScreenButton,
  faLocationDot,
  faEnvelope,
  faUserDoctor,
  faHeadSideCough,
  faBookMedical,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";

// Lazy load route components
const About = lazy(() => import("./About"));
const Services = lazy(() => import("./Services"));
const OccupationalTherapyInLucknow = lazy(() => import("./OccupationalTherapyInLucknow"));
const BehavioralTherapyInLucknow = lazy(() => import("./BehavioralTherapyInLucknow"));
const CerebralPalsyTreatmentInLucknow = lazy(() => import("./CerebralPalsyTreatmentInLucknow"));
const HyperactivityTreatmentInLucknow = lazy(() => import("./HyperactivityTreatmentInLucknow"));
const AbaTherapyInLucknow = lazy(() => import("./AbaTherapyInLucknow"));
const SpeechTherapyInLucknow = lazy(() => import("./SpeechTherapyInLucknow"));
const NoPage = lazy(() => import("./NoPage"));
const Events = lazy(() => import("./Events"));
const PhotoGallery = lazy(() => import("./PhotoGallery"));
const VideoGallery = lazy(() => import("./VideoGallery"));
const ParentalEducation = lazy(() => import("./ParentalEducation"));
const BlogSingle = lazy(() => import("./BlogSingle"));
const ClientFeedback = lazy(() => import("./ClientFeedback"));
const ContactUs = lazy(() => import("./ContactUs"));
const JobVacancies = lazy(() => import("./JobVacancies"));
const BookAppointment = lazy(() => import("./BookAppointment"));

library.add(
  faCheckSquare,
  faCoffee,
  faMobileScreenButton,
  faLocationDot,
  faEnvelope,
  faUserDoctor,
  faHeadSideCough,
  faBookMedical,
  faAngleRight,
);
function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <div className="App">
        <Header />
        <main id="main-content">
          <Suspense fallback={<div className="loading-spinner">Loading...</div>}>
            <Switch>
              <Route exact path="/about" component={About} />
              <Route exact path="/services" component={Services} />
              <Route exact path="/events" component={Events} />
              <Route exact path="/photo-gallery" component={PhotoGallery} />
              <Route exact path="/video-gallery" component={VideoGallery} />
              <Route exact path="/blog" component={ParentalEducation} />
              <Route exact path="/blog/:slug" component={BlogSingle} />
              <Route exact path="/client-feedback" component={ClientFeedback} />
              <Route exact path="/contact" component={ContactUs} />
              <Route exact path="/job-vacancies" component={JobVacancies} />
              <Route exact path="/book-appointment" component={BookAppointment} />
              <Route
                exact
                path="/occupational-therapy-in-lucknow"
                component={OccupationalTherapyInLucknow}
              />
              <Route
                exact
                path="/behavioral-therapy-in-lucknow"
                component={BehavioralTherapyInLucknow}
              />
              <Route
                exact
                path="/cerebral-palsy-treatment-in-lucknow"
                component={CerebralPalsyTreatmentInLucknow}
              />
              <Route
                exact
                path="/hyperactivity-treatment-in-lucknow"
                component={HyperactivityTreatmentInLucknow}
              />
              <Route exact path="/aba-therapy-in-lucknow" component={AbaTherapyInLucknow} />
              <Route exact path="/speech-therapy-in-lucknow" component={SpeechTherapyInLucknow} />
              <Route exact path="/" component={ContentIndex} />
              <Route path="*" component={NoPage} />
            </Switch>
          </Suspense>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
